import { useEventStore } from "@/event";

/** EVENTIUM row unlock level in UI grids — gated until an event is active. */
export function getEventiumUnlockLevelThreshold(): number {
	return useEventStore().isActive ? 1 : Number.MAX_SAFE_INTEGER - 1;
}
